import { Injectable, inject, signal, computed } from '@angular/core';
import { Subscription } from 'rxjs';
import { SubscriptionService } from './api/subscription.service';
import { AuthService } from './auth';
import { SubscriptionAlert } from '../core/models/subscription.model';
import { RoleId } from '../core/models/role.model';

@Injectable({ providedIn: 'root' })
export class AlertsPanelService {
  private _subscriptionService = inject(SubscriptionService);
  private _authService         = inject(AuthService);
  private _sub!: Subscription;

  readonly isOpen  = signal(false);
  readonly alerts  = signal<SubscriptionAlert[]>([]);
  readonly loading = signal(false);

  readonly isVisible = this._authService.hasRoleId(RoleId.GESTOR) ||
                       this._authService.hasRoleId(RoleId.EDITOR);

  readonly alertCount = computed(() => this.alerts().length);
  readonly hasAlerts  = computed(() => this.alertCount() > 0);

  constructor() {
    if (this.isVisible) {
      this.loading.set(true);
      this._sub = this._subscriptionService.getAlerts().subscribe({
        next:  (res) => { this.alerts.set(res?.data ?? []); this.loading.set(false); },
        error: ()    => this.loading.set(false),
      });
    }
  }

  toggle(): void { this.isOpen.update(v => !v); }
  open():   void { this.isOpen.set(true); }
  close():  void { this.isOpen.set(false); }

  getIcon(type: string): string {
    const map: Record<string, string> = {
      trial_expired:        'cilBadge',
      trial_expiring:       'cilBadge',
      users_near_limit:     'cilPeople',
      campaigns_near_limit: 'cilChart',
      registers_near_limit: 'cilFile',
    };
    return map[type] ?? 'cilBell';
  }

  getLabel(type: string): string {
    const map: Record<string, string> = {
      trial_expired:        'Prueba vencida',
      trial_expiring:       'Prueba por vencer',
      users_near_limit:     'Límite de usuarios',
      campaigns_near_limit: 'Límite de campañas',
      registers_near_limit: 'Límite de registros',
    };
    return map[type] ?? 'Alerta';
  }

  getSeverity(type: string): 'danger' | 'warning' {
    return type === 'trial_expired' ? 'danger' : 'warning';
  }
}
